import type {ReactElement} from 'react';
import Divider from '@Components/divider';
import type {DividerProps} from '@Components/divider/divider';
import styles from './field-spacer.module.scss';

export function FieldSpacer({...props}: DividerProps): ReactElement<any> | null {
  return <Divider {...props} height={props.height ?? 16} additionalClasses={styles.divider} />;
}
